export default "__VITE_ASSET__DR03QTrP__"